export default __webpack_public_path__ + "media/zurb/img/events/wired/lsa/life-services-image3-facfab4160d6057690afa8ac57e10cb3.jpg";